import { DialogTitle as NovaBaseDialogTitle } from '@fme-nova/components'
import { DialogTitle as MuiBaseDialogTitle, DialogTitleProps, styled } from '@mui/material'

import { createComponentWrapperWithRef, uiTokens } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiDialogTitle: MsdkStyledComponent<DialogTitleProps> = styled(MuiBaseDialogTitle)`
  background-color: ${COLORS.grey50};
  padding: 16px 24px;
`

const NovaDialogTitle: MsdkStyledComponent<DialogTitleProps> = styled(NovaBaseDialogTitle)`
  & h6,
  & .MuiTypography-h6 {
    font-weight: ${uiTokens.font.fontWeight.semiBold};
  }

  & .MuiButtonBase-root {
    position: absolute;
    right: 6px;
  }
`

export const DialogTitle = createComponentWrapperWithRef<DialogTitleProps>(
  {
    mui: MuiDialogTitle,
    nova: NovaDialogTitle,
  },
  'DialogTitle',
)
